module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Join-2-a91f7e363ffbcff93b7d63d10922c6e7.svg";